import { useState } from "react";
import SerachInput from "./components/SerachInput";
import { AccordionCustomIcon } from "./components/Accordion";
import { SideMenuItems } from "./constants/SideMenuItems";

const HelpSupport = () => {
  const [selectedMenuItem, setSelectedMenuItem] = useState(0);

  return (
    <div className="px-4">
      {/* search input */}
      <SerachInput />

      {/* flex box */}
      <div className="my-4 flex items-start justify-between gap-4">
        {/* side bar */}
        <div className="basis-1/6">
          <ul className="rounded-md bg-white p-4 shadow-md">
            {SideMenuItems.map((menuItem, index) => {
              return (
                <li
                  key={index}
                  className={`relative cursor-pointer border-b border-gray-300 py-2`}
                  onClick={() => setSelectedMenuItem(index)}
                >
                  {selectedMenuItem === index && (
                    <div className="absolute -left-4 top-0 h-full w-1 rounded-r bg-black"></div>
                  )}
                  <a className={`text-gray-600 ${selectedMenuItem === index && `text-black`}`}>
                    {menuItem.MenuItem}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>

        {/* accordion view goes here */}
        <div className="basis-5/6">
          <AccordionCustomIcon accordionItems={SideMenuItems[selectedMenuItem]} />
        </div>
      </div>
    </div>
  );
};

export default HelpSupport;
